import { useState } from "react";
import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { isLimitError, usePlan, useRefreshPlan } from "@/lib/plan";

export function OrganiseCard({ session }) {
  const qc = useQueryClient();
  const { data: plan } = usePlan();
  const refresh = useRefreshPlan();
  const [busy, setBusy] = useState(false);
  const left = plan?.plan === "free" ? Math.max(0, plan.usage.ai_logs_limit - plan.usage.ai_logs_used) : null;
  const organise = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/sessions/${session.id}/organise`);
      qc.setQueryData(["session", session.id], data);
      qc.invalidateQueries({ queryKey: ["sessions"] });
      refresh();
      toast.success("Organised with AI");
    } catch (err) {
      toast.error(errorMessage(err));
      if (isLimitError(err)) refresh();
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="card p-4" data-testid="session-plain-card">
      <div className="font-semibold text-sm">Saved as plain notes</div>
      <p className="text-[13px] text-[#A1A1AA] mt-1">Organise it with AI to split it into what you learned, what worked and what to fix, and include it in your analytics.</p>
      {left === 0 ? (
        <Link to="/pro" className="btn-primary w-full mt-3" data-testid="session-organise-upgrade">Go Pro to organise now</Link>
      ) : (
        <button onClick={organise} disabled={busy} className="btn-primary w-full mt-3" data-testid="session-organise-button">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <>Organise with AI{left !== null ? ` (${left} left this week)` : ""}</>}
        </button>
      )}
    </div>
  );
}
